export default __webpack_public_path__ + "static/media/museosans-500.ddb32980.ttf";